import React, { useEffect, useState } from "react";
//import Plotly from 'plotly.js-dist';
import createPlotlyComponent from "react-plotly.js/factory";
import { Definition } from "../../../../../data/Definition";
import { getProperty } from "../../../utils/dwHelpers";
import { useUnitConversion, formatUnitAbbreviation} from '../../../utils/unitConversion';
import { useStore } from '../../../providers/AppProvider';

const Plot = createPlotlyComponent(window.Plotly);
const _ = require('lodash');

export type StackedPlotConfig = {
    title: string;
    traces: any[]
}

interface Props {
    onClick?: (depth: number) => void
  }

type StatsProps = {
    definition: Definition | null,
    metric: string,
    description: string,
    loading: boolean,
    dataSoilStats: any | null,
    dataSoilDRLStats: any | null,
    propertyUnitsData: any | null,
}
 
const AboveWidgetSoilWaterCell = ({ 
    definition,
    metric, 
    description, 
    loading, 
    dataSoilStats,
    dataSoilDRLStats,
    propertyUnitsData,
}: StatsProps) => {

    const [plotConfig, setPlotConfig] = useState<any>(null);
    const [preferredLenSmall, setPreferredLenSmall] = useState<any>(null);
    const [preferredLenAbbr, setPreferredLenAbbr] = useState<any>("in");
    const [updateKey, setUpdateKey] = useState<number>(0);

    const { localePreferences } = useStore();
    const { convertToPreferredUnitValue, convertToPreferredUnitString, unitsConvert } = useUnitConversion();

    let PAW_cumulitive = 0;
    let PAWC_cumulitive = 0;
    let count_cumulative = 0;
    useEffect(() => {
        if (dataSoilStats && dataSoilDRLStats && (dataSoilStats.length > 0)){
            console.log("030823 dataSoilStats", dataSoilStats);
            console.log("080423 definition", definition);
            dataSoilStats.forEach((s:any, i:number) => {
                PAW_cumulitive = PAW_cumulitive + s[`${getProperty(definition, ['paw'])?.property}_mean`];
                PAWC_cumulitive = PAWC_cumulitive + s[`${getProperty(definition, ['paw'])?.property}_mean`];
                count_cumulative++;
            });
            let ERZ = dataSoilStats[dataSoilStats.length - 1].top; //120.0;
            let PAWC_calc = (PAWC_cumulitive / count_cumulative) / 100 * ERZ;
            let PAW_calc = (PAW_cumulitive / count_cumulative) / 100 * ERZ;
            console.log("BB112222 PAWC_calc", PAWC_calc);
            console.log("BB112222 PAW_calc", PAW_calc);
            let df = {
                "ERZ": ERZ,
                "PAWC_calc": PAWC_calc,
                "PAW_calc": PAW_calc,
                "DEP": ((PAWC_calc - PAW_calc) < 0) ? 0 : (PAWC_calc - PAW_calc), // Do not let value go below 0.
                "AD": PAWC_calc * 0.4, 
            }
            
            /*
                bottom
                top
                Calcium_mean
                FC_mean
                KSAT_mean
                PAWC_mean
                Magnesium_mean
                Moisture_mean
                Nitrogen_mean
                paw_mean
                PWP_mean
                Phosphorus_mean
                Potassium_mean
                Saturation_mean
                pH_mean
                plant_id
                plant_name
                plant_time
            */
            let centered_width = 0;
            //[`${getProperty(definition, ['pwp'])?.property}_mean`]
            dataSoilStats.forEach((e:any, index:number) => {
                console.log("BB112122 e", e);
                console.log("A080423 getProperty(definition, ['paw'])", getProperty(definition, ['paw'])?.property);
                console.log("A080423 e[`${getProperty(definition, ['saturation'])?.property}_mean`]", e[`${getProperty(definition, ['saturation'])?.property}_mean`]);
                if (centered_width === 0){
                    centered_width = e.bottom / 2;
                }
                console.log("120424 definition", definition);
                console.log("120424 e", e);
                console.log("120424 getProperty(definition, ['fc'])", getProperty(definition, ['fc']));
                console.log("120424 getProperty(definition, ['saturation'])", getProperty(definition, ['saturation']));
                console.log("120424 getProperty(definition, ['porosity'])", getProperty(definition, ['porosity']));
                //df[`FW_${e.top}`] = e[`${getProperty(definition, ['porosity'])?.property}_mean`];
                // Actually you want to keep that formula, because it calculates the stacked portion of the graph.  In that formula, you should replace saturation with porosity from DW.  You may need to determine whether to multiply by 100 based on whether porosity appears to be 0-1 (multiply by 100), or 0-100 (don't multiply).  Also, for extra credit you could handle Saturation and Porosity depending on what's in the data definition.
                if (getProperty(definition, ['porosity'])){
                    //df[`FW_${e.top}`] = e[`${getProperty(definition, ['porosity'])?.property}_mean`] - e[`${getProperty(definition, ['fc'])?.property}_mean`];
                    _.set(df, [`FW_${e.top}`], e[`${getProperty(definition, ['porosity'])?.property}_mean`] - e[`${getProperty(definition, ['fc'])?.property}_mean`]);
                }else{ // ORIGINAL FORMULA (pre 12/04/24)
                    _.set(df, [`FW_${e.top}`], e[`${getProperty(definition, ['saturation'])?.property}_mean`] * 100 - e[`${getProperty(definition, ['fc'])?.property}_mean`]);
                }
                _.set(df, [`PAW_${e.top}`], e[`${getProperty(definition, ['paw'])?.property}_mean`]);
                _.set(df, [`PWP_${e.top}`], e[`${getProperty(definition, ['pwp'])?.property}_mean`]);
                _.set(df, [`PAWC_${e.top}`], e[`${getProperty(definition, ['pawc'])?.property}_mean`]);
                _.set(df, [`chart_bottom`], e.bottom);
                //df[`FW`] ? df[`FW`].push(e[`${getProperty(definition, ['porosity'])?.property}_mean`]) : df[`FW`] = e[`${getProperty(definition, ['porosity'])?.property}_mean`];
                if (getProperty(definition, ['porosity'])){
                    _.get(df, [`FW`]) 
                        ? _.get(df, [`FW`]).push(e[`${getProperty(definition, ['porosity'])?.property}_mean`] - e[`${getProperty(definition, ['fc'])?.property}_mean`]) 
                        : _.set(df, [`FW`],     [e[`${getProperty(definition, ['porosity'])?.property}_mean`] - e[`${getProperty(definition, ['fc'])?.property}_mean`]]);
                }else{
                    _.get(df, [`FW`]) 
                        ? _.get(df, [`FW`]).push(e[`${getProperty(definition, ['saturation'])?.property}_mean`] * 100 - e[`${getProperty(definition, ['fc'])?.property}_mean`]) 
                        : _.set(df, [`FW`],     [e[`${getProperty(definition, ['saturation'])?.property}_mean`] * 100 - e[`${getProperty(definition, ['fc'])?.property}_mean`]]);
                }
                _.get(df, [`PAW`]) ? _.get(df, [`PAW`]).push(e[`${getProperty(definition, ['paw'])?.property}_mean`]) : _.set(df, [`PAW`], [e[`${getProperty(definition, ['paw'])?.property}_mean`]]);
                _.get(df, [`PWP`]) ? _.get(df, [`PWP`]).push(e[`${getProperty(definition, ['pwp'])?.property}_mean`]) : _.set(df, [`PWP`], [e[`${getProperty(definition, ['pwp'])?.property}_mean`]]);
                _.get(df, [`KSAT`]) ? _.get(df, [`KSAT`]).push(e[`${getProperty(definition, ['ksat'])?.property}_mean`]) : _.set(df, [`KSAT`], [e[`${getProperty(definition, ['ksat'])?.property}_mean`]]);
                let preppedSaturation = (e[`${getProperty(definition, ['saturation'])?.property}_mean`] * 100 - e[`${getProperty(definition, ['fc'])?.property}_mean`]) + e[`${getProperty(definition, ['pawc'])?.property}_mean`] + e[`${getProperty(definition, ['pwp'])?.property}_mean`];
                let clampedMoisture = (e[`${getProperty(definition, ['moisture'])?.property}_mean`] <= 0) ? 0 : ((e[`${getProperty(definition, ['moisture'])?.property}_mean`] > preppedSaturation) ? preppedSaturation : e[`${getProperty(definition, ['moisture'])?.property}_mean`]);
                _.get(df, [`Moisture`]) ? _.get(df, [`Moisture`]).push(clampedMoisture) : _.set(df, [`Moisture`], [clampedMoisture]);
                _.get(df, [`PAWC`]) ? _.get(df, [`PAWC`]).push(e[`${getProperty(definition, ['paw'])?.property}_mean`]) : _.set(df, [`PAWC`], [e[`${getProperty(definition, ['paw'])?.property}_mean`]] );
                _.get(df, [`depths`]) ? _.get(df, [`depths`]).push(e.bottom) : _.set(df, [`depths`], [e.bottom]);
                _.get(df, [`depths_centered`]) ? _.get(df, [`depths_centered`]).push(e.bottom - centered_width) : _.set(df, [`depths_centered`], [e.bottom - centered_width]);
            })
            console.log("120424 df", df);
            console.log("BB120124 dataSoilDRLStats", dataSoilDRLStats);
            /*
                bottom
                top
                Root Limited Moisture_mean
                drl_mean
                plant_id
                plant_name
                plant_time
            */
            setPlotConfig(df)
        }else{
            //
        }   
    }, [dataSoilStats, dataSoilDRLStats]);

    useEffect(() => {
        const _preferredLenSmall = _.get(localePreferences, 'measureUnits.length.small');
        const _preferredLenAbbr: string =
            typeof _preferredLenSmall === 'string' ? _preferredLenSmall : _preferredLenSmall?.abbr || 'in';
        setPreferredLenSmall(_preferredLenSmall);
        setPreferredLenAbbr(_preferredLenAbbr);
    }, [localePreferences]);

    useEffect(() => {
        console.log("B092425 definition", definition);
        console.log("B092425 metric", metric);
        console.log("B092425 description", description);
        console.log("B092425 loading", loading);
        console.log("B092425 dataSoilStats", dataSoilStats);
        console.log("B092425 dataSoilDRLStats", dataSoilDRLStats);
        console.log("B092425 propertyUnitsData", propertyUnitsData);
        setUpdateKey((prevKey) => prevKey + 1);
    }, [definition,
        metric, 
        description, 
        loading, 
        dataSoilStats,
        dataSoilDRLStats,
        propertyUnitsData]);

    const onClick = (e:any) => {
        console.log("CLICK e", e);
    }

    //let waterfig = make_subplots( // .py code that seems to have no use
    //        rows=1,
    //        cols=2
    //    )
    //console.log("030823 plotConfig", plotConfig);
    const cmInterval = plotConfig ? plotConfig.depths[0] : 30;
    return (
        <>
        { 
          plotConfig &&
          <Plot
            config={{            
                displayModeBar: false,
            }}
            key={`updatePlot${updateKey}`}
            data={[
                {
                    
                    name: 'DEP', 
                    type:'bar',  
                    x: [plotConfig.ERZ],
                    y: [plotConfig.DEP],
                    xaxis: 'x1',
                    width: cmInterval,
                    legendgroup:"ERZ",
                    marker: {
                        color:"red",
                        line: {
                            color: 'darkred',
                            width: 2,
                        }
                    },
                },{
                    name: 'PAW',
                    type:'bar', 
                    x: [plotConfig.ERZ],
                    y: [plotConfig.PAW_calc],
                    xaxis: 'x1',
                    width: cmInterval,
                    legendgroup:"ERZ",
                    marker: {
                        color:"blue",
                        line: {
                            color: 'darkblue',
                            width: 2, 
                        }
                    },
                },{
                    name: 'ERZ',
                    type:'bar', 
                    x: [plotConfig.ERZ],
                    y: [plotConfig.ERZ - plotConfig.PAW_calc],
                    xaxis: 'x1',
                    width: cmInterval,
                    legendgroup:"ERZ",
                    marker: {
                        color:"slategray",
                        line: {
                            color: 'darkslategrey',
                            width: 2,
                        }
                    },
                },{
                    name: 'Unavailable Water',
                    type:'bar', 
                    x: plotConfig.PWP,
                    y: plotConfig.depths_centered,
                    orientation: "h",
                    xaxis: 'x2',
                    width: cmInterval,
                    legendgroup:"Moisture %",
                    marker: {
                        color: "orange",
                        line: {
                            color: 'darkorange', 
                            width: 2,
                        },
                    },
                },{
                    name: 'AWHC',
                    type:'bar', 
                    x: plotConfig.PAWC,
                    y: plotConfig.depths_centered,
                    orientation: "h",
                    xaxis: 'x2',
                    legendgroup:"Moisture %",
                    width: cmInterval,
                    marker: {
                        color: "green",
                        line: {
                            color: 'darkgreen',
                            width: 2,
                        },
                    }
                },{
                    name: 'Drainage',
                    type:'bar', 
                    x: plotConfig.FW,
                    //x: plotConfig.FW && plotConfig.FW.map((v: number) => (v < 0 ? 0 : v)),
                    y: plotConfig.depths_centered,
                    orientation: "h",
                    xaxis: 'x2',
                    legendgroup:"Moisture %",
                    width: cmInterval,
                    marker: {
                        color: "mediumblue",
                        line: {
                            color: 'darkblue',
                            width: 2,
                        }
                    },
                },{
                    name: 'Moisture',
                    type:'bar', 
                    x: plotConfig.Moisture,
                    y: plotConfig.depths_centered,
                    orientation: "h",
                    xaxis: 'x3',
                    legendgroup:"Moisture %",
                    width: cmInterval / 2,
                    marker: {
                        color: "darkblue",
                        line: {
                            color: 'darkblue', 
                            width: 2,
                        }
                    },
                },{
                    name: 'KSAT',
                    type:'bar', 
                    x: plotConfig.KSAT,
                    y: plotConfig.depths_centered,
                    orientation: "h",
                    xaxis: 'x4',
                    legendgroup:"KSAT",
                    width: cmInterval,
                    marker: {
                        color:  "paleturquoise",
                        line: {
                            color: 'turquoise', 
                            width: 2,
                        },
                        opacity:0.95,
                    },
                },
            ]}
            layout={{
                legend: {
                    x: 0,
                    y: 0,
                    orientation: "h",
                },
                grid: {
                    rows: 1, 
                    columns: 2, 
                    //pattern: 'independent'
                },
                //hovermode:'closest',
                barmode:'stack', 
                height:300,
                width:475,
                title:'',
                //title_x:0.5,
                margin: {
                    t: 40,
                    b: 5,
                    l: 40,
                    r: 20
                },
                xaxis1: {
                    side: "top",
                    title: "ERZ",
                    range: [0, 60],
                    domain: [0, 0.2],
                    autorange: true,
                    showgrid: true,
                    gridwidth: 2,
                    gridcolor:'black',
                    showline:true,
                    linewidth:2,
                    linecolor:'black',
                    mirror:true,
                    showticklabels:false,
                },
                xaxis2: {
                    anchor: "y",
                    side: "top",
                    title: "Moisture (%)",
                    range: [0, 60],
                    domain: [0.22, 0.6],
                    autorange: false,
                    showgrid: true,
                    gridwidth: 2,
                    gridcolor:'black',
                    showline:true,
                    linewidth:2,
                    linecolor:'black',
                    mirror:true,
                },
                xaxis3: {
                    overlaying: "x2",
                    anchor: "y",
                    //overlaying:true,
                    side: "top",
                    title: "",
                    range: [0, 60],
                    domain: [0.22, 0.6],
                    autorange: false,
                    showgrid: true,
                    gridwidth: 2,
                    gridcolor:'black',
                    showline:true,
                    linewidth:2,
                    linecolor:'black',
                    mirror:true,
                },
                xaxis4: {
                    anchor: "y",
                    side: "top",
                    title: "KSat (cm/hr)",
                    range: [0, 60],
                    domain: [0.63, 1.0],
                    autorange: true,
                    showgrid: true,
                    gridwidth: 2,
                    gridcolor:'black',
                    showline:true,
                    linewidth:2,
                    linecolor:'black',
                    mirror:true,
                },
                yaxis: {
                    side: "left",
                    range: [plotConfig.chart_bottom, 0.0], // Need to adjust for actual depth + a little extra
                    title: `Depth (${preferredLenAbbr})`,
                    domain: [0.0, 1.0],
                    autorange: false,
                    type: "linear",
                    showgrid: true,
                    gridwidth: 2,
                    gridcolor:'black',
                    tick0:0,
                    dtick:cmInterval,
                    showline:true,
                    linewidth:2,
                    linecolor:'black',
                    mirror:true,
                },
                paper_bgcolor:"rgba(0,0,0,0)",
                plot_bgcolor:"rgba(0,0,0,0)"
            }}
            //useResizeHandler={true}
            //style={{width: "100%", height: "100%"}}
            //onClick={(e:any) => {
            //  if(e.points.length && onClick) {
            //    convert the clicked poisition to data position
            //    const bb = e.event.target.getBoundingClientRect();
            //    const y = e.points[0].yaxis.p2d(e.event.clientY - bb.top);
            //    onClick(y);
            //  }
            //}}
          />
         }
        </>
    );
}

export default AboveWidgetSoilWaterCell;